export enum ProjectEvaluationStatus {
	Pending = "Pending",
	Submitted = "Submitted",
	Published = "Published",
	Rejected = "Rejected"
}

export enum EvaluatorType {
	Client = "Client",
	Freelancer = "Freelancer"
}

export interface ProjectEvaluation {
	id: number;
	projectId: number;
	projectName?: string;
	projectNumber?: string;
	freelancerProfileId: number;
	evaluatorType: EvaluatorType;
	assignedToUserId?: number;
	assignedToFirstName?: string;
	assignedToLastName?: string;
	assignedToJobTitle?: string;
	rating?: number;
	comment?: string;
	consentGiven: boolean;
	status: ProjectEvaluationStatus;
	submittedAt?: string;
	moderatedAt?: string;
	evaluatedByUserId?: number;
	evaluatedByFirstName?: string;
	evaluatedByLastName?: string;
	evaluatorFirstName?: string;
	evaluatorLastName?: string;
	evaluatorCompanyName?: string;
	freelancerFirstName?: string;
	freelancerLastName?: string;
}

export interface FreelancerProfileEvaluationSummary {
	averageRating?: number;
	totalCount: number;
	evaluations: ProjectEvaluation[];
}

export interface SubmitProjectEvaluationRequest {
	rating: number;
	comment: string;
	consentGiven: boolean;
}

export interface ModerateProjectEvaluationRequest {
	newStatus: ProjectEvaluationStatus;
}

export interface UpdateProjectEvaluationRequest {
	rating?: number;
	comment?: string;
}

export interface ProjectEvaluationSearchResult {
	items: ProjectEvaluation[];
	totalCount: number;
	pageSize: number;
	currentPage: number;
	totalPages: number;
}
